import { useQuery } from '@tanstack/react-query';
import { config } from '@shared/config';
import type { EventListItem } from '@fanini/shared-types';

/** Shape eines Events für den Scanner (Alias für EventListItem aus shared-types). */
export type ApiEvent = EventListItem;

/**
 * Hook zum Laden der veröffentlichten Events.
 * Nutzt den Public-Endpoint direkt (ohne Auth-Token), da `/api/public/events`
 * keine Authentifizierung erfordert und für alle Rollen erreichbar sein muss.
 *
 * @returns TanStack Query Result mit der Events-Liste
 *
 * @example
 * ```tsx
 * const { data: events, isLoading } = useEvents();
 * ```
 */
export function useEvents() {
  return useQuery<ApiEvent[]>({
    queryKey: ['scanner', 'events', 'published'],
    queryFn: async () => {
      const baseUrl = config.apiUrl.replace(/\/api\/?$/, '');
      const res = await fetch(`${baseUrl}/api/public/events`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json() as Promise<ApiEvent[]>;
    },
  });
}
